const seriesMap = {
  WE000: 'Wave II Series 0',
  WE002: 'Wave Performance Series 0',
  WE003: 'Wave II Series 1',
};

function normalize(input) {
  return (input || '')
    .toString()
    .replace(/[.\-\s]/g, '')
    .toUpperCase();
}

function getWaveSeries(productNumber) {
  const code = normalize(productNumber).substring(0, 5);
  return seriesMap[code] || code;
}

function getSeriesCodeByName(name) {
  if (!name) return null;
  const normalized = name.toString().trim().toLowerCase();
  const entry = Object.entries(seriesMap).find(([, n]) => n.toLowerCase() === normalized);
  return entry ? entry[0] : null;
}

module.exports = { getWaveSeries, getSeriesCodeByName, seriesMap };
